<template>
  <ModuleContainer v-bind="bindModule">
    <template #btn>
      <MapControlButton
        icon="mdi-chart-pie"
        :active="isOpen"
        :tooltip="'Thống kê bản đồ'"
        @click="isOpen = !isOpen"
      />
    </template>
    <template #draggable="props">
      <DraggablePopup
        v-bind="props"
        :show.sync="isOpen"
        :title="'Thống Kê Dữ Liệu'"
        :top="popupTop"
        :width="650"
        :height="720"
        :left="popupLeft"
        :right="popupRight"
        :is-resizable="true"
        :min-width="450"
        :min-height="500"
      >
        <div class="full-height full-width d-flex flex-column overflow-hidden pa-3" @mousedown="blurSelect">
          <!-- Dropdown Chọn Lớp (Single Select) -->
          <div @mousedown.stop>
            <v-select
              ref="layerSelect"
              v-model="selectedLayerId"
              :items="availableLayers"
              item-text="name"
              item-value="id"
              clearable
              hide-details
              outlined
              dense
              label="Chọn lớp dữ liệu..."
              class="visible-border-select"
            ></v-select>
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- Dashboard -->
          <div class="flex-grow-1 overflow-hidden d-flex flex-column">
            <StatisticDashboard v-if="selectedLayerId" :layerIds="[selectedLayerId]" :layerMap="layerMap" />
            <div v-else class="text-center grey--text py-8 d-flex flex-column align-center justify-center fill-height">
              <v-icon size="48" color="grey lighten-1">mdi-chart-box-outline</v-icon>
              <div class="mt-2 text-subtitle-2">Vui lòng chọn lớp dữ liệu để xem thống kê</div>
            </div>
          </div>
        </div>
      </DraggablePopup>
    </template>
  </ModuleContainer>
</template>

<script>
import MapControlButton from './MapControlButton.vue'
import StatisticDashboard from '../../statistic/StatisticDashboard.vue'
import ModuleContainer from '../ModuleContainer.vue'
import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'

export default {
  name: 'StatisticControl',
  mixins: [ModuleMixin],
  components: { MapControlButton, StatisticDashboard, ModuleContainer, DraggablePopup },
  props: {
    position: {
      type: String,
      default: 'top-right',
    },
    popupTop: { type: Number, default: 80 },
    popupLeft: { type: [Number, String], default: null },
    popupRight: { type: [Number, String], default: 60 },
    layers: {
      type: Array,
      default: () => [],
    },
    headless: { type: Boolean, default: false }
  },
  data() {
    return {
      isOpen: false,
      selectedLayerId: null,
    }
  },
  watch: {
    isOpen(val) {
      this.$emit('update:open', val);
      this.$emit('change', val);
    },
    availableLayers: {
      handler(layers) {
        if (layers && layers.length > 0 && !this.selectedLayerId) {
          this.selectedLayerId = layers[0].id
        }
      },
      immediate: true
    }
  },
  computed: {
    availableLayers() {
      return (this.layers || []).map(l => {
        // Lấy đúng ID thực của CSDL (uuid hoặc id) thay vì ID ngẫu nhiên của Mapbox Layer
        const realId = l.info ? (l.info.uuid || l.info.id) : l.id;
        return {
          id: realId,
          name: l.name || (l.info ? l.info.name : 'Unknown Layer')
        };
      });
    },
    layerMap() {
      const map = {}
      this.availableLayers.forEach(l => { map[l.id] = l.name })
      return map
    },
  },
  methods: {
    blurSelect() {
      if (this.$refs.layerSelect) {
        this.$refs.layerSelect.isMenuActive = false;
        this.$refs.layerSelect.blur();
      }
    }
  }
}
</script>

<style>
/* Tăng độ ưu tiên (specificity) để ghi đè được file _light.scss */
.theme--light .v-text-field--outlined.visible-border-select:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset,
.visible-border-select .v-input__slot fieldset {
  border-color: #94a3b8 !important;
  border-width: 1px !important;
}
</style>
<style scoped>
/* Không cần style thủ công nữa vì đã dùng DraggablePopup */
</style>
